module.exports = __webpack_public_path__ + "static/media/logo.00559a6e.svg";